<template>
  <v-btn color="grey darken-1" outlined tile v-bind="$attrs" v-on="$listeners"
    ><slot></slot
  ></v-btn>
</template>

<script>
export default {
  name: "OutlinedTiledBtn",
};
</script>
